import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { DialogContext } from './DialogContext';
import Button from '../../components/Button';
import Icon from '../../components/Icon';

const propTypes = {};

const defaultProps = {};

const useStyles = makeStyles(theme => ({
  dialog: {
    textAlign: 'center',
  },
  icon: {
    fontSize: 88,
  },
  content: {
    fontSize: 16,
  },
  actions: {
    justifyContent: 'center',
    padding: theme.spacing(1, 3),
  },
}));

function ConfirmDialog() {
  const {
    showDialog,
    type,
    content,
    isLoading,
    onConfirm,
    onCancel,
  } = React.useContext(DialogContext);

  const classes = useStyles();

  const dialogTypes = {
    success: {
      actions: (
        <Button color="success" square disabled={isLoading} onClick={onCancel}>Aceptar</Button>
      ),
      color: 'success',
      icon: 'check_circle',
    },
    info: {
      actions: (
        <React.Fragment>
          <Button color="error" square disabled={isLoading} onClick={onConfirm}>Aceptar</Button>
          <Button color="primary" square disabled={isLoading} onClick={onCancel}>Cancelar</Button>
        </React.Fragment>
      ),
      color: 'secondary',
      icon: 'error',
    },
    error: {
      actions: (
        <Button color="error" square disabled={isLoading} onClick={onCancel}>Aceptar</Button>
      ),
      color: 'error',
      icon: 'cancel',
    },
  };

  const dialogProps = {
    classes: { root: classes.dialog },
    fullWidth: true,
    maxWidth: 'xs',
    open: showDialog,
  };
  const contentProps = {
    classes: { root: classes.content },
  };
  const actionProps = {
    classes: { root: classes.actions },
  };

  const title = (
    <Icon
      classes={{ root: classes.icon }}
      icon={dialogTypes[type].icon}
      color={dialogTypes[type].color}
    />
  );

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent {...contentProps}>{content}</DialogContent>
      <DialogActions {...actionProps}>{dialogTypes[type].actions}</DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = propTypes;
ConfirmDialog.defaultProps = defaultProps;

export default ConfirmDialog;
